// extracted by mini-css-extract-plugin
module.exports = {"link":"Headline__link--2uuJf","headline":"Headline__headline--32KDc","bounce":"Headline__bounce--35Rof"};